import { ArrowRight } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import HiddenOpportunities from '../../../modules/dashboard/components/HiddenOpportunities';
import { DEMO_HIDDEN_OPPORTUNITIES } from '../../../modules/dashboard/utils/buildHiddenOpportunities';
import { trackCTA } from '../../../utils/metaPixel';

interface HomeHiddenOpportunitiesSectionProps {
  onNavigate?: (view: string) => void;
}

const HomeHiddenOpportunitiesSection: React.FC<HomeHiddenOpportunitiesSectionProps> = ({
  onNavigate,
}) => {
  const { t } = useTranslation();

  const handleCta = () => {
    trackCTA('hidden_opportunities_home');
    onNavigate?.('signup');
  };

  return (
    <section className="home-hidden-opportunities" aria-labelledby="home-hidden-opportunities-heading">
      <div className="home-hidden-opportunities__inner">
        <p id="home-hidden-opportunities-heading" className="home-hidden-opportunities__eyebrow">
          {t('home.hiddenOps.eyebrow', 'Beyond title matching')}
        </p>
        <h2 className="home-hidden-opportunities__headline">
          {t('home.hiddenOps.headline', 'Discover jobs you are unusually qualified for')}
        </h2>
        <p className="home-hidden-opportunities__lede">
          {t(
            'home.hiddenOps.lede',
            'GoGrabJob uses semantic AI to find high-fit roles your current title would never surface on ordinary job boards.',
          )}
        </p>

        <HiddenOpportunities
          opportunities={DEMO_HIDDEN_OPPORTUNITIES}
          demoMode
          className="home-hidden-opportunities__card"
        />

        <div className="home-hidden-opportunities__cta-row">
          <button type="button" onClick={handleCta} className="home-hidden-opportunities__cta">
            {t('home.hiddenOps.cta', 'Find my hidden opportunities')}
            <ArrowRight className="w-4 h-4" aria-hidden />
          </button>
        </div>
      </div>
    </section>
  );
};

export default HomeHiddenOpportunitiesSection;
